import axios from "axios";
import { API_URL } from "../utils/constant";
import {
  SUBDOMAIN_FETCHED,
  SUBDOMAIN_FETCHED_GRAPH,
  SUBDOMAIN_FETCHED_TOTAL,
  SUBDOMAIN_FETCHED_EXP,
  FETCH_SUBDOMAIN_DETAIL,
  SUBDOMAIN_SCAN_STARTED,
  SUBDOMAIN_FETCHED_SSL_GRAPH,
  SUBDOMAIN_FETCHED_SSL_TOTAL,
  LOOK_ALIKE_FETCHED,
  INVENTORY_DETAILS_FETCHEDV1,
  FETCH_DNS_DETAILS,
  FETCH_SUCCESS_DNS_DETAILS,
  SECURITY_HEADER,
  REMEDIATION_DATA_ADDED,
  REMEDIATION_DATA_REMOVED,
  REMEDIATION_DATA_GET,
  FETCH_SUCCESS_DNS_DETAILS_GRAPH,
  FETCH_SUCCESS_DNS_DETAILS_TOTAL,
  REMEDIATION_DATA_TOTAL,
  GET_PROCESS_LIST,
  GET_PROCESS_CONTAINERS,
  GET_PROCESS_CONTAINERS_BODY_LIST,
} from "./index";
import { toastr } from "react-redux-toastr";
import $ from "jquery";

// import { toastr } from 'react-redux-toastr';

export const addRemediationData = (data, dispatch) => {
  return new Promise((resolve, reject) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    if (data === undefined) {
      reject("Invalid ID");
      return null;
    } else {
      axios
        .patch(`${API_URL}/ticket-system/`, data)
        .then((response) => {
          dispatch({
            type: REMEDIATION_DATA_ADDED,
            payload: response.data,
          });
          if (response.data.status == 200) {
            toastr.success("Success", response.data.userMessage);
            getRemediationData(dispatch, data?.organisationId, 1);
            // Also refresh the counters to keep them accurate
            remediationDataTotal(dispatch, data?.organisationId);
            resolve();
          } else {
            toastr.success("Error", response.data.userMessage);
            reject(response.data.userMessage);
          }
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
};

export const removeRemediationData = (id, dispatch, orgId) => {
  return new Promise((resolve, reject) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    if (id === undefined) {
      reject("Invalid ID");
    } else {
      axios
        .delete(`${API_URL}/ticket-system/${id}/delete`)
        .then((response) => {
          dispatch({
            type: REMEDIATION_DATA_REMOVED,
            payload: response.data,
          });
          if (response.data.status === 200) {
            toastr.success("Success", response.data.userMessage);
            getRemediationData(dispatch, orgId, 1);
            // Also refresh the counters to keep them accurate
            remediationDataTotal(dispatch, orgId);
            resolve();
          } else {
            toastr.error("Error", response.data.userMessage);
            reject(response.data.userMessage);
          }
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
};

export const getRemediationData = (dispatch, id, page) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return null;
  } else {
    axios
      .get(`${API_URL}/ticket-system/${id}/list?page=${page}&limit=10`)
      .then((response) => {
        dispatch({
          type: REMEDIATION_DATA_GET,
          payload: response.data,
        });
      });
  }
};

export const getProcessList = (dispatch, id, currentItems = null) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return Promise.resolve(null);
  }
  // Simple approach: Use the existing POST endpoint that was working before
  return axios
    .post(`${API_URL}/ticket-system/${id}/process-tickets`)
    .then((response) => {
      dispatch({
        type: GET_PROCESS_LIST,
        payload: response.data,
      });

      // Refresh the remediation data after processing
      getRemediationData(dispatch, id, 1);

      // Refresh the counters after processing
      remediationDataTotal(dispatch, id);

      // Show success message
      if (response.data.success !== false) {
        $.confirm({
          title: "Success",
          content: "Items processed successfully and moved to Remediation Mode",
          type: "green",
          buttons: {
            ok: {
              text: "OK",
              btnClass: "btn-success",
              keys: ["enter"],
              action: function () {
                window.location.reload();
                // Optional: do something after success
              },
            },
          },
        });
      } else if (response.data.hasNullTaskTypeRecords) {
        $.confirm({
          title: "Error Message",
          content: response.data.errorMsg,
          type: "red",
          buttons: {
            ok: {
              text: "OK",
              btnClass: "btn-danger",
              keys: ["enter"],
              action: function () {
                // Optional: handle error
              },
            },
          },
        });
      }
    })
    .catch((error) => {
      console.error("Error processing list:", error);
      $.confirm({
        title: "Error",
        content: "Failed to process items. Please try again.",
        type: "red",
        buttons: {
          ok: {
            text: "OK",
            btnClass: "btn-danger",
            keys: ["enter"],
            action: function () {
              // Optional: handle error
            },
          },
        },
      });
    });
};

export const getContainersList = (dispatch, id) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return null;
  } else {
    axios.get(`${API_URL}/ticket-system/${id}/containers`).then((response) => {
      dispatch({
        type: GET_PROCESS_CONTAINERS,
        payload: response.data,
      });
    });
  }
};

export const getContainersBodyList = (dispatch, id, cntID) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return null;
  } else {
    axios
      .get(`${API_URL}/ticket-system/${id}/containers/${cntID}`)
      .then((response) => {
        dispatch({
          type: GET_PROCESS_CONTAINERS_BODY_LIST,
          payload: response.data,
        });
      });
  }
};

export const getRemediationActionType = (dispatch, id, data, orgId) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return null;
  } else {
    return axios
      .put(`${API_URL}/ticket-system/${id}/actiontype`, data)
      .then((response) => {
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
          // Don't automatically refresh the entire list to prevent reordering
          // Only refresh if explicitly needed
          if (data.refreshList) {
            getRemediationData(dispatch, orgId, 1);
          }
        } else {
          toastr.error("Error", response.data.userMessage);
        }
        return response;
      })
      .catch((error) => {
        toastr.error("Error", "Failed to update action type");
        throw error;
      });
  }
};

export const getRemediationActionNote = (dispatch, id, data, orgId) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return null;
  } else {
    return axios
      .put(`${API_URL}/ticket-system/${id}/update-note`, data)
      .then((response) => {
        // Only show success message if explicitly requested
        if (data.showSuccessMessage) {
          toastr.success("Success", response.data.message);
        }
        // Don't automatically refresh the entire list to prevent reordering
        // getRemediationData(dispatch, orgId, 1);
        return response;
      })
      .catch((error) => {
        toastr.error("Error", "Failed to update note");
        throw error;
      });
  }
};

export const getRemediationActionRating = (dispatch, id, data, orgId) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return null;
  } else {
    return axios
      .put(`${API_URL}/ticket-system/${id}/update-rating`, data)
      .then((response) => {
        // Check for successful response (200 status or success flag)
        if (response.status === 200 || response.data.success) {
          toastr.success(
            "Success",
            response.data.message || "Rating updated successfully"
          );
        } else {
          toastr.error(
            "Error",
            response.data.message || "Failed to update rating"
          );
        }
        // Don't automatically refresh to prevent reordering
        // getRemediationData(dispatch,orgId,1);
        return response;
      })
      .catch((error) => {
        console.error("Rating update error:", error);
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Failed to update rating";
        toastr.error("Error", errorMessage);
        throw error;
      });
  }
};

export const remediationDataReset = (dispatch, id) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return null;
  } else {
    return axios
      .put(`${API_URL}/ticket-system/reset`, id)
      .then((response) => {
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
          // Refresh both the remediation data and totals
          getRemediationData(dispatch, id.organisationId, 1);
          remediationDataTotal(dispatch, id.organisationId);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
        return response;
      })
      .catch((error) => {
        toastr.error("Error", "Failed to reset selections");
        throw error;
      });
  }
};

export const remediationDataTotal = (dispatch, id) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    //console.log("remediationDataTotal: No organization ID provided");
    return null;
  } else {
    //console.log("remediationDataTotal: Fetching totals for org ID:", id);
    axios
      .get(`${API_URL}/ticket-system/${id}/getTotalActionTypeCounts`)
      .then((response) => {
        //console.log("remediationDataTotal: Success response:", response.data);
        dispatch({
          type: REMEDIATION_DATA_TOTAL,
          payload: response.data,
        });
      })
      .catch((error) => {
        console.error("remediationDataTotal: Error fetching totals:", error);
      });
  }
};

export const getRemediationAction = (dispatch, id, data, page, category) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (id === undefined) {
    return null;
  } else {
    axios
      .post(
        `${API_URL}/ticket-system/${id}/action?page=${page}&category=${category}`,
        data
      )
      .then((response) => {
        dispatch({
          type: REMEDIATION_DATA_GET,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      });
  }
};

export const fetchWebTech = (
  props,
  page,
  dispatch,
  category,
  filterData,
  searchBy,
  searchValue,
  minExploitabilityScore,
  severity
) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .get(
        `${API_URL}/webtech_analysis/${props}/delta?pageno=${page}&category=${category}&searchBy=${searchBy}&q=${searchValue}&type=${filterData}&minExploitabilityScore=${minExploitabilityScore}&severity=${severity}`
      )
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0070";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchWebTechAction = (props, page, dispatch, category, data) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(
        `${API_URL}/webtech_analysis/${props}/action?pageno=${page}&category=${category}`,
        data
      )
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      });
  }
};

export const fetchWebTechGraph = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .get(`${API_URL}/webtech_analysis/${props}/graph`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0071";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchWebTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .get(`${API_URL}/webtech_analysis/${props}/totals`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0072";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchSubDomains = (
  props,
  page,
  dispatch,
  category,
  domain_search_query,
  status
) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  //console.log('fetchSubDomains called with:', { props, page, category, domain_search_query, status });

  if (props === undefined) {
    return null;
  } else {
    const url = `${API_URL}/expired-ssl-certificates/${props}/delta?page=${page}&category=${category}&domain_search_query=${domain_search_query}&status=${status}`;
    //console.log('API URL:', url);
    axios
      .get(url)
      .then((response) => {
        //console.log('API Response:', response.data);
        dispatch({
          type: SUBDOMAIN_FETCHED_EXP,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.error("API Error:", err);
        let message = "Server code : F0073";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_EXP,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchSubDomainsAction = (
  props,
  dispatch,
  page,
  category,
  data
) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .post(
        `${API_URL}/expired-ssl-certificates/${props}/action?page=${page}&category=${category}`,
        data
      )
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_EXP,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Server code : F0073";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_EXP,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchSubDomainsTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/expired-ssl-certificates/${props}/totals`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_SSL_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0074";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_SSL_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchSubDomainsGraph = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/expired-ssl-certificates/${props}/graph`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_SSL_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0075";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_SSL_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const addSubDmoan = (props, dispatch) => {
  //export const addSubDomain = (props, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .post(`${API_URL}/createSubDomain`, { ...props })
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
          return false;
        } else {
          toastr.success("Success", response.data.userMessage);
        }
        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0076";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        toastr.error("Error", message);
        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const startScanSubdomain = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(`${API_URL}/start-scan/${props.subdomain}`)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          toastr.success("Success", response.data.userMessage);
        }
        dispatch({
          type: SUBDOMAIN_SCAN_STARTED,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0077";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        toastr.error("Error", message);
        dispatch({
          type: SUBDOMAIN_SCAN_STARTED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const getSubDetails = (props, dispatch) => {
  //console.log(props);
  if (props !== undefined) {
    axios.get(`${API_URL}/dns-details/${props}`).then((res) => {
      if (res.data.error) {
        toastr.error("ERROR", "Something went wrong");
      } else {
        toastr.success("SUCCESS", "Data Fetched.");
      }
      dispatch({
        type: FETCH_SUBDOMAIN_DETAIL,
        subDomainDetail: res.data,
      });
    });
  }
};

export const subDomainScan = (props, dispatch) => {
  //console.log(props);
  if (props !== undefined) {
    // const cookie = new Cookies();
    // const session = cookie.get("session");
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios.post(`${API_URL}/start-scan`, props).then((res) => {
      if (res.data.error) {
        toastr.error("ERROR", res.data.userMessage);
        return false;
      } else {
        toastr.success("SUCCESS", "Scan started.");
      }
      if (props.isVulnerabilities) {
        dispatch({
          type: INVENTORY_DETAILS_FETCHEDV1,
          data: res.data.data,
        });
      } else {
        dispatch({
          type: LOOK_ALIKE_FETCHED,
          payload: res.data,
        });
      }
    });
  }
};

export const getDnsDetails = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getDnsDetails/${props}`)
      .then((response) => {
        dispatch({
          type: FETCH_DNS_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0078";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_DNS_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const getSubDomainDetailsdan = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getSubDomainDetails/${props}`)
      .then((response) => {
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0079";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchSecurityHeader = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getSecurityHeader/${props}`)
      .then((response) => {
        // console.log(response.data,"response.data")
        dispatch({
          type: SECURITY_HEADER,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0080";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SECURITY_HEADER,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const getSubDomainDetails = (
  props,
  dispatch,
  page,
  category,
  status,
  domainquery,
  domain
) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(
        `${API_URL}/getSubDomainDetails/${props}/delta?page=${page}&category=${category}&status=${status}&domainquery=${domainquery}&domain=${domain}`
      )
      .then((response) => {
        //console.log(response,'response')
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        let message = "Server code : F0081";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const getSubDomainDetailsAction = (
  props,
  dispatch,
  page,
  category,
  status,
  domainquery,
  domain,
  data
) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .post(
        `${API_URL}/getSubDomainDetails/${props}/action?page=${page}&category=${category}&status=${status}&domainquery=${domainquery}&domain=${domain}`,
        data
      )
      .then((response) => {
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0082";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const getSubDomainDetailsTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getSubDomainDetails/${props}/totals`)
      .then((response) => {
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0083";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const getSubDomainDetailsGraph = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getSubDomainDetails/${props}/graph`)
      .then((response) => {
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Server code : F0084";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

/**
 * Process current remediation list by updating isProcessed to true for multiple items
 * This is used by the "Process Current List" functionality in rightnav.js
 */
export const processCurrentRemediationList = (recordIds, organizationId) => {
  return new Promise((resolve, reject) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    if (!recordIds || !Array.isArray(recordIds) || recordIds.length === 0) {
      reject("Invalid record IDs provided");
      return;
    }

    // Process each record individually using the existing PATCH endpoint
    const processPromises = recordIds.map((recordId) => {
      const updateData = {
        _id: recordId,
        organizationId: organizationId,
        isProcessed: true, // Set to processed
      };

      return axios.patch(`${API_URL}/ticket-system/`, updateData);
    });

    Promise.all(processPromises)
      .then((responses) => {
        // Check if all updates were successful
        const allSuccessful = responses.every(
          (response) => response.data.status === 200
        );

        if (allSuccessful) {
          resolve({
            success: true,
            message: `Successfully processed ${recordIds.length} items`,
            processedCount: recordIds.length,
          });
        } else {
          reject("Some items failed to process");
        }
      })
      .catch((error) => {
        console.error("Error processing current list:", error);
        reject(
          error.response?.data?.userMessage ||
            "Failed to process remediation list"
        );
      });
  });
};
